
  //import {Vue} from "vue-property-decorator";
  //import Component from "vue-class-component";
  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import { Alert } from "@/addons/Alert";
  //import { http } from "@/config/HttpClient";
  import { DateTime } from "luxon";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  
  @Component({
    name: "CrearCita",
  })
  
  export default class CrearCita extends Vue {
    @Prop() ventaEdit!: any
    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
    private tab:any = null;
    public dialog = false;
    public codigo = '';
    public cuenta = '';
    public numero = '';
    cliente_seleccionado = '';
    pacientes_all = [];
    public paciente= {
      codigo: '',
      cuenta: '',
      nombre: '',
      direccion: '',
      nit: '',
      telefono: '',
      placa: '',
      periodo: ''
    };
    cita= {
        paciente: '',
        paciente_ci: '',
        paciente_id: null,
        tratamiento_id: '',
        fecha: DateTime.now().toFormat("yyyy-MM-dd"),
        hora: DateTime.now().toFormat("HH:mm"),
        motivo: '',
        observaciones: ''
    }
    periodos = [{descripcion: 'Indefinido'},{descripcion: '1 año'},{descripcion: 'Unica ocasion'}]
    swEditar = true;
    valid = true;
    fecha = DateTime.now().toFormat('yyyy-MM-dd');
    
    get pacientes(): any {
      return this.consultorioStore.pacientes;
    }
    get tratamientos(): any {
      return this.consultorioStore.tratamientos;
    }
    private fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
    private fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");
    txtSearch = "";
    selected_paciente = {};
    mounted(){
      this.getTratamientos();
    }
    
   
    closePaciente(){
      this.dialog=false;
    }
    newPaciente(){
      this.dialog = true;
    }
    asignarPaciente(paciente:any){
      this.paciente = paciente;
    }
    getPacientesSearch(value:string){
      this.loading
      this.consultorioService.getPacientesSearch(value).then(res => {
        console.log(res);
        //this.pacientes_all = res;
      })
    }
    getTratamientos(){
      this.consultorioService.getTratamientos()
    }
    
    guardar(){
      if (!this.$refs.form.validate()) {
        Alert.warning( `Lene todos los campos obligatorios (*)`)
          return;
        }
      if(this.swEditar){
        Alert.confirm(`Se realizará el registro de la cita del paciente ${this.cita.nombre_completo}`, 'Registrar nueva Cita?').then(async result => {
          if(result.isConfirmed){
            await this.consultorioService.registrarCita(this.cita).then(response =>{
              
              this.limpiar()
            })
            
          }
        })
      }else {
        Alert.confirm(`Se realizará la modificacion de la venta`, 'Modificar venta?').then(async result => {
          if(result.isConfirmed){
            await this.consultorioService.editarVenta(this.venta)
            this.limpiar()
          }
        })
      }
      
    }
    seleccionCliente(){
      console.log(this.selected_paciente)
      if(this.paciente !== null){
        this.cita.paciente = this.selected_paciente.nombre_completo;
        this.cita.paciente_ci = this.selected_paciente.ci;
        this.cita.paciente_id = this.selected_paciente.id;
        
      }else
      this.limpiar()
      
    }
    de_editar(){
      if(Object.entries(this.$route.params).length == 0)
        return
      if( Object.entries(this.$route.params.ventaEdit).length !== 0 && this.$route.params.ventaEdit.constructor === Object){
        this.swEditar = false;
        
        this.cliente= {
          codigo: this.$route.params.ventaEdit.cliente.codigo,
          cuenta: this.$route.params.ventaEdit.cliente.cuenta,
          nombre: this.$route.params.ventaEdit.cliente.nombre,
          direccion: this.$route.params.ventaEdit.cliente.direccion,
          nit: this.$route.params.ventaEdit.cliente.nit,
          telefono: this.$route.params.ventaEdit.cliente.telefono,
          placa: this.$route.params.ventaEdit.cliente.placa,
          periodo: this.$route.params.ventaEdit.cliente.periodo,
        };
        this.venta = {
          codigo: this.$route.params.ventaEdit.codigo,
          cantidad_m3: this.$route.params.ventaEdit.cantidad_m3,
          total_venta: this.$route.params.ventaEdit.total_venta,
          fecha_hora: DateTime.now().toFormat('yyyy-MM-dd'),
          es_cancelado: this.$route.params.ventaEdit.es_cancelado,
          destino: this.$route.params.ventaEdit.destino,
          placa: this.$route.params.ventaEdit.placa,
          users_id: '',
          cliente_id: this.$route.params.ventaEdit.cliente.id,
          uso_id: this.$route.params.ventaEdit.uso_id,
          fuente_id: this.$route.params.ventaEdit.fuente_id,
          id: this.$route.params.ventaEdit.id,
         
        }
      }
    }
    limpiar(){
      this.cita= {
        paciente: '',
        paciente_ci: '',
        paciente_id: null,
        tratamiento_id: '',
        fecha: DateTime.now().toFormat("yyyy-MM-dd"),
        hora: DateTime.now().toFormat("HH:mm"),
        motivo: '',
        observaciones: ''
    }
    }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }
    @Watch('txtSearch')
    search(value: string) {
      console.log(value);
      if(value != null && value.length > 2){
        this.$nextTick().then( () => {
          this.getPacientesSearch(value);
        })
        
        this.pacientes_all = this.consultorioStore.pacientes;
        console.log(this.pacientes_all);
      }
      
  
      
    }
  }
  
  